/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gf_rpm_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speed`)
};

const es_gf_rpm_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad`)
};

const de_gf_rpm_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drehzahl`)
};

const nl_gf_rpm_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snelheid`)
};

const fr_gf_rpm_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitesse`)
};

const it_gf_rpm_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocità`)
};

const pt_br2_gf_rpm_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidade`)
};

const pt_gf_rpm_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidade`)
};

const ja_gf_rpm_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回転速度`)
};

const zh_gf_rpm_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转速`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gf_rpm_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gf_rpm_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gf_rpm_label", locale)
	if (locale === "en") return en_gf_rpm_label(inputs)
	if (locale === "es") return es_gf_rpm_label(inputs)
	if (locale === "de") return de_gf_rpm_label(inputs)
	if (locale === "nl") return nl_gf_rpm_label(inputs)
	if (locale === "fr") return fr_gf_rpm_label(inputs)
	if (locale === "it") return it_gf_rpm_label(inputs)
	if (locale === "pt-BR") return pt_br2_gf_rpm_label(inputs)
	if (locale === "pt") return pt_gf_rpm_label(inputs)
	if (locale === "ja") return ja_gf_rpm_label(inputs)
	return zh_gf_rpm_label(inputs)
};